<template>
    <div class="homeImages">
        <a class="aHref">
            <img class="icon" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back.jpg" alt="">
            <div class="coreContent wow animate__animated animate__bounceIn" data-wow-delay ="1.5s">
                <img src="../../../../public/images/logo.png" alt="">
            </div>
            <div class="coreData left_top wow animate__animated animate__bounceIn" data-wow-delay ="0.3s">
                <i class="icon iconfont iconjinrongFSxitong"></i>
                金融FS系统
            </div>
            <div class="coreData left_content wow animate__animated animate__bounceIn" data-wow-delay ="0.7s">
                <i class="icon iconfont iconmaoyishangerpxitong"></i>
                贸易商ERP系统
            </div>
            <div class="coreData left_bottom wow animate__animated animate__bounceIn" data-wow-delay ="1.1s">
                <i class="icon iconfont iconshujudmsxitong"></i>
                数据DMS系统
            </div>
            <div class="coreData right_top wow animate__animated animate__bounceIn" data-wow-delay ="0.9s">
                <i class="icon iconfont iconcheliangqmsxitong"></i>
                车辆QMS系统
            </div>
            <div class="coreData right_content wow animate__animated animate__bounceIn" data-wow-delay ="0.5s">
                <i class="icon iconfont iconcangkumsxitong"></i>
                仓库WMS系统
            </div>
            <div class="coreData right_bottom wow animate__animated animate__bounceIn" data-wow-delay ="1.3s">
                <i class="icon iconfont iconwuliulisxitong"></i>
                物流LIS系统
            </div>
        </a>
    </div>
</template>
<script>
import {WOW} from 'wowjs'
export default {
    data(){
        return{
             
        }
    },
    watch:{
        
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    created(){
        
    },
    methods:{
        
    }
}
</script>
<style scoped  lang="scss">
    .homeImages .aHref{width: 100%;height:100%;position: relative; overflow: hidden;display: block;border-radius: 0.4rem;}
    .homeImages .aHref .icon{max-width: 100%;vertical-align: middle;transition: all .6s;}
    .homeImages .aHref .icon:hover{transform:scale(1.1);cursor: pointer;}
    .coreData{
        width: 7rem;
        height: 7rem;
        padding: 2rem;
        border-radius: 50%;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .icon{font-size: 3.5rem;margin-bottom: 1rem;color: #5784F4;}
    }
    .coreContent{
        width: 22rem;
        height: 9rem;
        border-radius: 4rem;
        background: #fff;
        position: absolute;
        left: 42%;
        top: 42%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .left_top{
        position: absolute;
        left: 27%;
        top: 5%;
    }
    .left_content{
        position: absolute;
        left: 10%;
        top: 40%;
    }
    .left_bottom{
        position: absolute;
        left: 24%;
        top: 70%;
    }
    .right_top{
        position: absolute;
        left: 70%;
        top: 5%;
    }
    .right_content{
        position: absolute;
        left: 80%;
        top: 40%;
    }
    .right_bottom{
        position: absolute;
        left: 64%;
        top: 70%;
    }
</style>